<div class="flex align-items-center">
  @if (tenantId) {
  <img
    class="app-logo"
    #appLogo
    [ngSrc]="publicResourcesUrl + tenantId + '/logo.png'"
    (error)="appLogo.remove()"
    alt="Customer Logo"
    width="180"
    height="30"
    priority
  />
  }
</div>
